import { useLocation } from "@remix-run/react";
import { useCallback, useEffect } from "react";

const useOnSlugMatch = (slug?: string, onMatch?: () => void) => {
  const location = useLocation();

  const handleHashChange = useCallback(
    (hash: string) => {
      if (Boolean(slug) && hash.split("#")[1] === slug) {
        onMatch?.();
      }
    },
    [slug, onMatch]
  );

  useEffect(() => {
    handleHashChange(location.hash);
  }, [handleHashChange, location.hash]);
};

export default useOnSlugMatch;
